module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Food/Coffee#1-680b80167ebe2d3e8d1c0c951197db8c58623ddb53b8328952963b41dd364838.svg";